import * as DialogPrimitive from '@radix-ui/react-dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { cn } from '../../../lib/utils';

export const CharlieDialog = DialogPrimitive.Root;
export const CharlieDialogTrigger = DialogPrimitive.Trigger;
export const CharlieDialogClose = DialogPrimitive.Close;
export const CharlieDialogPortal = DialogPrimitive.Portal;

export type CharlieDialogOverlayProps = React.ComponentPropsWithoutRef<
  typeof DialogPrimitive.Overlay
>;

export function CharlieDialogOverlay({
  className,
  ...props
}: CharlieDialogOverlayProps) {
  return (
    <DialogPrimitive.Overlay
      data-slot="dialog-overlay"
      className={cn(
        'fixed inset-0 z-50 bg-black/60',
        'data-[state=open]:animate-in data-[state=open]:fade-in-0',
        'data-[state=closed]:animate-out data-[state=closed]:fade-out-0',
        className,
      )}
      {...props}
    />
  );
}

export interface CharlieDialogContentProps extends React.ComponentPropsWithoutRef<
  typeof DialogPrimitive.Content
> {
  hideClose?: boolean;
  header?: React.ReactNode;
}

export function CharlieDialogContent({
  hideClose = false,
  header,
  className,
  children,
  ...props
}: CharlieDialogContentProps) {
  return (
    <CharlieDialogPortal>
      <CharlieDialogOverlay />
      <DialogPrimitive.Content
        data-slot="dialog-content"
        className={cn(
          'fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2',
          'w-full max-w-md overflow-clip rounded-2xl border border-border bg-background shadow-lg',
          'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]',
          'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]',
          className,
        )}
        {...props}
      >
        {!hideClose && (
          <div className="flex items-start justify-between p-2 pl-8 gap-4">
            {header && <div className="pt-2">{header}</div>}
            <DialogPrimitive.Close className="flex shrink-0 items-center justify-center size-9 rounded-full text-foreground/70 transition-opacity hover:opacity-100 ml-auto">
              <FontAwesomeIcon icon={faXmark} className="size-4" />
              <span className="sr-only">Close</span>
            </DialogPrimitive.Close>
          </div>
        )}
        <div
          className={cn('flex flex-col gap-8 px-8 pb-8', hideClose && 'pt-8')}
        >
          {children}
        </div>
      </DialogPrimitive.Content>
    </CharlieDialogPortal>
  );
}
